export enum State {
    ANNOTATION_ACTIVE = 1,
    RANGE_ACTIVE = 2,
    ALARMS_ACTIVE = 3,
    NO_ENTRY = 4,
    ZOOM = 5
}

